import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "corner-inside-arc-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none" },
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M14 3.5V14H3.5V9.5a6 6 0 0 0 6-6H14Z", opacity: 0.2 }),
        React.createElement("path", { stroke: "currentColor", d: "M3.5 14V9.5a6 6 0 0 0 6-6H14" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
